function scrollTo(btn, scrollto) {
  if(!btn || !scrollto) return;
  
  document.querySelector(btn)?.addEventListener('click', function(e){
    e.preventDefault();
    document.querySelector(scrollto).scrollIntoView({ behavior: "smooth", block: "start" });
  })
}

function inView(selectors, callback, options = { root: null, threshold: 0.1 }) {
  const observer = new IntersectionObserver((entries) => { entries.forEach(entry => callback(entry, observer)); }, options);
  selectors.forEach(selector => {
    let element = document.querySelector(selector);
    if (element) observer.observe(element);
  });
}

function complementaryProduct(e) {
  let complementaryContainer = document.querySelector("product-recommendations.layout__pp");

  if (e.detail.intent !== "complementary" || !complementaryContainer) return;

  let form = document.getElementById("complementaryProductForm");
  if (form) {
    new theme.AjaxProduct(form);
  }

  let productSelectInputs = complementaryContainer.querySelectorAll(".cpSelector");

  productSelectInputs.forEach(function (input) {
    input.addEventListener("click", function () {
      let id = this.dataset.id;
      let setQty = form.querySelector("#" + id)?.querySelector(".quantity");

      if (input.checked) {
        let qty = this.closest(".grid-product").querySelector('input[form="' + id + '"]').value;
        setQty.value = qty;
      } else {
        setQty.value = "0";
      }
    });
  });

  let qtySelectors = complementaryContainer.querySelectorAll(".js-qty__wrapper");

  qtySelectors?.forEach((qtySelector) => {
    new theme.QtySelector(qtySelector);
  });

  theme.initQuickShop();
}

function recommendationTab() {
  let container = document.querySelector(".recommendations__tab");

  if (!container) return;

  let tab = container.querySelector(".tab");

  tab.addEventListener("click", function () {
    this.classList.toggle("active");
    this.parentElement.classList.toggle("show-recommendation");
  });
}

function copyDiscountCodes() {
  let discountContainer = document.getElementById("currentOffers");

  if (!discountContainer) return;

  let codes = discountContainer.querySelectorAll(".discount_code-copyBtn");

  codes.forEach((code) => {
    code.addEventListener("click", function () {
      let codeWrapper = this.closest(".offer-item");
      let codeInput = codeWrapper.querySelector(".discount_code-copy");
      copyInputValue(codeInput);
      this.innerText = "Copied";
    });
  });
}

function copyInputValue(input) {
  const range = document.createRange();
  range.selectNode(input);

  const selection = document.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);

  document.execCommand("copy");
  selection.removeAllRanges();
}

class DeliveryTime extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.update();
  }

  static get observedAttributes() {
    return ["data-available", "data-delivery", "data-message"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (["data-available", "data-delivery", "data-message"].includes(name)) {
      this.update();
    }
  }

  getDate(dayNumber) {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const date = new Date();
    date.setDate(date.getDate() + dayNumber);
    return `${date.getDate()} ${months[date.getMonth()]}`;
  }

  update() {
    const isAvailable = this.dataset.available === "true";
    this.shadowRoot.innerHTML = "";

    if (!isAvailable) {
      this.classList.add("hide");
      return;
    }

    const delivery = this.dataset.delivery;
    const msg = this.dataset.message || "Get it by [startdate] - [enddate].";
    const parts = delivery.split(",");

    if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
      const deliveryTime = parseInt(parts[0], 10);
      const deliveryGap = parseInt(parts[1], 10);
      const startDay = Math.max(deliveryTime - deliveryGap, 1);

      const startDate = this.getDate(startDay);
      const endDate = this.getDate(deliveryTime);
      const finalTime = msg.replace("[startdate]", startDate).replace("[enddate]", endDate);

      this.shadowRoot.textContent = finalTime;
    } else {
      this.shadowRoot.textContent = delivery;
    }
  }
}

customElements.define("delivery-time", DeliveryTime);

function quickProductAdd() {
  let forms = document.querySelectorAll(".quickProductAdd");
  if (forms.length) forms.forEach((form) => new theme.AjaxProduct(form));
}

document.addEventListener("drawerOpen.NavDrawer", function () {
  let announcement = document.querySelector(".announcement-bar");
  let header = document.querySelector("#SiteHeader");

  if (!announcement && !header) return;
  
  let visibleHeight = 0;

  let elements = [announcement, header].filter(Boolean);
  visibleHeight = elements.reduce((sum, element) => sum + getVisibleHeight(element), 0);

  if (visibleHeight > 0) document.body.style.setProperty("--visible-header-height", visibleHeight + "px");
  else document.body.style.removeProperty("--visible-header-height");
});

function getVisibleHeight(el) {
  let rect = el.getBoundingClientRect();
  let visiblePart = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
  return visiblePart > 0 ? Math.round(visiblePart) : 0;
}

function collapsiblesAutoClose() {
  const drawer = document.getElementById("NavDrawer");
  const subNavDrawer = document.getElementById("subNavigationDrawer");

  if (!drawer || !subNavDrawer) return;

  const collapsibles = drawer.querySelectorAll(".pp-collapsible-trigger");
  const subNavs = subNavDrawer.querySelectorAll(".pp-collapsible-content");

  collapsibles.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      const id = this.getAttribute("aria-controls");
      const targetSubNav = document.getElementById(id);
      const isAlreadyOpen = this.classList.contains("is-open");

      collapsibles.forEach(el => el.classList.remove("is-open"));
      subNavs.forEach(subNav => subNav.classList.remove("show"));

      if (!isAlreadyOpen) {
        this.classList.add("is-open");
        targetSubNav.classList.add("show");

        if (drawer.parentElement && !drawer.parentElement.classList.contains('second-drawer-open')) {
          drawer.parentElement.classList.add('second-drawer-open');
        }
      } else {
        if (drawer.parentElement) { drawer.parentElement.classList.remove('second-drawer-open'); }
      }
    });
  });
}

function gridSlider() {
  let sliders = document.querySelectorAll(".grid--slider");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    let grid = slider.querySelector(".grid");
    let items = grid.querySelectorAll(".grid__item").length;

    if(grid.classList.contains('.flickity-enabled')) { return; }

    let per_row = grid.dataset.perRow;

    if(theme.config.bpSmall) {
      if(items <= 2) { return }
    } else {
      if(per_row >= items) { return; }
    }

    new Flickity(grid, {
      wrapAround: true,
      contains: true,
      cellAlign: "left",
      pageDots: false,
      prevNextButtons: true,
    });
  });
}

function productRecommendationSlider() {

  let recommendation = document.querySelector('.shopify-section product-recommendations .grid');

  if(!recommendation) return;
  if(window.matchMedia('(max-width: 768px)').matches) return;

  let items = recommendation.querySelectorAll('.grid__item');

  if(items.length < 6) { return; }

  new Flickity(recommendation, {
    wrapAround: true,
    contains: true,
    cellAlign: "left",
    pageDots: false,
    prevNextButtons: true,
  });
}

document.addEventListener('matchSmall', gridSlider);
document.addEventListener('matchSmall', subCollectionSlider);

function subCollectionSlider() {
  let slider = document.querySelector('.subCategory .grid');
  let items = slider?.querySelectorAll('.grid__item').length;

  if(slider) { 
    slider.style.display = 'flex';
  }

  if(!slider || !theme.config.bpSmall || items < 5 || !document.body.classList.contains('template-collection')) return;

  new Flickity(slider, {
    wrapAround: true,
    contains: true,
    cellAlign: 'left',
    freeScroll: true,
    prevNextButtons: false,
    pageDots: true
  });
}

function tracking() {
  let form = document.getElementById("trackingFields");

  if (!form) return;

  let tracking_id = form.querySelector("input").value;

  if(!tracking_id) {
    alert("please enter tracking ID");
    return;
  }
  
  if (tracking_id.match(/^\d/)) window.location.assign("https://www.delhivery.com/track/package/" + tracking_id);
  else window.location.assign("https://international.delhivery.com/#/trackdetail/" + tracking_id);
}

function stickyAddToCart(entry) {
  if (!document.body.classList.contains('template-product')) return;

  const target = entry.target;

  if (target.matches(".product-single__form")) document.body.classList.toggle("main-buttons-view", entry.isIntersecting);
  if (target.matches("#shopify-section-footer") && entry.isIntersecting) document.body.classList.remove("main-buttons-view");
}

function collectionArrow() {
  if (!theme.config.bpSmall) return;

  const collections = document.querySelectorAll('[data-context="featured-collection"]');
  if (!collections.length) return;

  collections.forEach(collection => {
    const container = collection.querySelector('.grid-overflow-wrapper');
    const leftArrow = collection.querySelector('.left');
    const rightArrow = collection.querySelector('.right');

    if (!container || !leftArrow || !rightArrow) return;

    const scrollAmount = 200;

    const updateArrows = () => {
      leftArrow.style.display = container.scrollLeft > 0 ? 'block' : 'none';
      rightArrow.style.display = container.scrollLeft + container.clientWidth < container.scrollWidth ? 'block' : 'none';
    };

    updateArrows();
    container.addEventListener('scroll', updateArrows);

    leftArrow.addEventListener('click', () => {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', () => {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  });
} 

document.addEventListener("recommendations:loaded", complementaryProduct);

function changeFaqText() {
  let contents = document.querySelectorAll('#FAQsContainer .content');
  
  if (!contents.length || !document.body.classList.contains('template-product')) return; 

  contents.forEach(content => {
    if (content.textContent.includes('12-15 business days')) {
      content.textContent = content.textContent.replace('12-15 business days', '15-20 business days');
    }
  });
}

function setWhatsAppLink() {
  const links = document.querySelectorAll('a[href="whatsapp_dynamic_url"]');
  const currentURL = window.location.href;

  const baseURL = "https://api.whatsapp.com/send/?phone=919653171608&text=";

  let messageText;
  if (currentURL.includes("/products/")) {
    messageText = `Hey, can I get faster delivery? ${currentURL}`;
  } else {
    messageText = currentURL;
  }

  const finalURL = `${baseURL}${encodeURIComponent(messageText)}`;

  links.forEach(link => link.setAttribute("href", finalURL));
}

function cartTabs() {
    const btns = document.querySelectorAll(".cart-tabs .btn-group");
    const contents = document.querySelectorAll(".cart-tab-content");

    btns.forEach(btn => {
      btn.addEventListener("click", () => {
        const targetId = btn.dataset.control;

        btns.forEach(btn => btn.classList.remove("active"));

        contents.forEach(content => content.classList.add("hide"));

        btn.classList.add("active");

        const target = document.getElementById(targetId);
        console.log(target)
        if (target) {
          target.classList.remove("hide");
        }
      });
    });
}

function copyOffer() {
  let btns = document.querySelectorAll(".copy-offer");
  if(!btns.length) return;

  btns.forEach(btn => {
      btn.addEventListener("click", function () {
      const code = this.getAttribute("data-code");

      navigator.clipboard.writeText(code).then(() => {
        const originalText = this.textContent;
        this.textContent = "Copied";

        setTimeout(() => {
          this.textContent = originalText;
        }, 2000);
      });
    });
  });

}


function selectAfterHiddenVariants(context = document) {
  const hiddenVariants = context.querySelectorAll('.variant-input.hidden-variant');

  if (!hiddenVariants.length) return;

  hiddenVariants.forEach(hiddenVariant => {
    const fieldset = hiddenVariant.closest('fieldset');
    if (!fieldset) return;

    const variants = Array.from(fieldset.querySelectorAll('.variant-input'));

    const startIndex = variants.indexOf(hiddenVariant) + 1;

    for (let i = startIndex; i < variants.length; i++) {
      const input = variants[i].querySelector('input[type="radio"]');

      if (input && !input.disabled) {
        const label = variants[i].querySelector('label');

        if (label) {
          label.click();
        }
        break;
      }
    }
  });
}


document.addEventListener('recommendations:loaded', productRecommendationSlider);

document.addEventListener("DOMContentLoaded", () => {
  collapsiblesAutoClose();
  subCollectionSlider();
  gridSlider();
  quickProductAdd();
  recommendationTab();
  copyDiscountCodes();
  scrollTo('.btn--pair-it-with', '.pp--trust-icons');
  inView([".product-single__form", "#shopify-section-footer"], stickyAddToCart);
  collectionArrow();

  changeFaqText();
  setWhatsAppLink();
  updateMealCount();
  cartTabs();
  copyOffer();
  selectAfterHiddenVariants();
});

function updateMealCount() {
  setTimeout(function(){
    const itemsContainer = document.querySelector('.cart__items');
    if (!itemsContainer) return;

    const items = itemsContainer.querySelectorAll('.cart__item');
    if (!items.length) return;

    const mealContainer = document.querySelector('.total__meals[data-meal]');
    if (!mealContainer) return;

    const totalMeals = Array.from(items).reduce((total, item) => {
      const qtyInput = item.querySelector('.js-qty__num');
      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      const mealPerItem = parseInt(item.dataset.meal, 0) || 0;

      return total + (mealPerItem * qty);
    }, 0);

    if(totalMeals == 0) {
      document.getElementById('CartDrawer')?.classList.add('zeroMeals');
    } else {
      mealContainer.innerText = `With this purchase sponsor ${totalMeals} meals`;
      document.getElementById('CartDrawer')?.classList.remove('zeroMeals');
    }
    
  },1000);
}


['ajaxProduct:added', 'cart:updated'].forEach(event => document.addEventListener(event, updateMealCount));